import { render, staticRenderFns } from "./rose.vue?vue&type=template&id=1132d3df&scoped=true"
import script from "./rose.vue?vue&type=script&lang=js"
export * from "./rose.vue?vue&type=script&lang=js"
import style0 from "./rose.vue?vue&type=style&index=0&id=1132d3df&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1132d3df",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Workplace\\vueProject\\edu_aim\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1132d3df')) {
      api.createRecord('1132d3df', component.options)
    } else {
      api.reload('1132d3df', component.options)
    }
    module.hot.accept("./rose.vue?vue&type=template&id=1132d3df&scoped=true", function () {
      api.rerender('1132d3df', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/we/rose.vue"
export default component.exports